<div
  *ngIf="asset"
  [class]="categoryName === 'Icons' ? 'icons-card' : 'card'"
  [ngClass]="{ scale: !editMode }"
>
  <div id="card-image" class="card-img" style="position: relative">
    <img
      id="asset-image"
      src="data:image/png;base64,{{ asset.thumbnail }}"
      style="max-width: 100%"
    />

    <div
      *ngIf="!editMode"
      class="favorite-overlay"
      (click)="onHeartClick($event)"
      title="Zu Favoriten hinzufügen/entfernen"
    >
      <cds-icon
        shape="heart"
        [attr.solid]="isFavorite ? '' : null"
        [class.is-liked]="isFavorite"
        size="24"
      >
      </cds-icon>
    </div>
  </div>

  <div class="card-block" *ngIf="showTitle" id="card-block">
    <p class="card-text" id="card-text">
      {{
        categoryName === "Icons"
          ? asset.title.split("_")![asset.title.split("_").length! - 1]
          : asset.title
      }}
    </p>
  </div>
</div>
